import { createReducer, INITIAL_STATE } from '@shared/redux';
import { LOAD_STATE } from '@shared/axios';
import { createSelector } from 'reselect';
import { TraktoDocument, TraktoTemplate } from './trakto.types';

export interface TraktoState {
    documents:{
        data: Array<unknown>;
        load: string;
        error: string;
    },
    templates:{
        data: Array<unknown>;
        load: string;
        error: string;
    }
}

export const LIST_DOCUMENTS_SET = '@partnerships/trakto/LIST_DOCUMENTS_SET';
export const LIST_TEMPLATES_SET = '@partnerships/trakto/LIST_TEMPLATES_SET';
export const DELETE_DOCUMENT = '@partnerships/trakto/DELETE_DOCUMENT';
export const CREATE_DOCUMENT = '@partnerships/trakto/CREATE_DOCUMENT';
export const SHARE_DOCUMENT = '@partnerships/trakto/SHARE_DOCUMENT';


export const traktoLoadingTemplatesSelector = state => state.partnerships.trakto.templates.load;
export const traktoLoadingDocumentsSelector = state => state.partnerships.trakto.documents.load;

export const traktoListDocumentsSelector = state => state.partnerships.trakto.documents.data;
const traktoListTemplatesSelector = state => state.partnerships.trakto.templates.data;

const getLocaleDate = (date: string) => (date ? new Date(date).toLocaleDateString() : null);

const mapTraktoEntity = entity => ({
    ...entity,
    createdAt: getLocaleDate(entity.created_at),
    updatedAt: getLocaleDate(entity.updated_at),
    thumb: entity.thumbs?.medium,
});

export const getDocumentsSelector = createSelector(
    traktoListDocumentsSelector,
    documents => documents.map(mapTraktoEntity),
);

export const getTemplatesSelector = createSelector(
    traktoListTemplatesSelector,
    templates => templates.map(mapTraktoEntity),
);

export const setListDocuments = (documents: Array<TraktoDocument> = []) => ({
    type: LIST_DOCUMENTS_SET,
    payload: { documents },
});

export const setListTemplates = (templates: Array<TraktoTemplate> = []) => ({
    type: LIST_TEMPLATES_SET,
    payload: { templates },
});

export const createDocument = () => ({
    type: CREATE_DOCUMENT,
    payload: {},
});

export const deleteDocument = (documentId: string) => ({
    type: DELETE_DOCUMENT,
    payload: { documentId },
});

export const shareDocument = (documentId: string, email: string) => ({
    type: SHARE_DOCUMENT,
    payload: { documentId, email },
});

const initialState: TraktoState = {
    documents: {
        data: [],
        load: LOAD_STATE.LOADING,
        error: null,
    },
    templates: {
        data: [],
        load: LOAD_STATE.LOADING,
        error: null,
    },
};

export const traktoReducer = createReducer({
    [INITIAL_STATE]: initialState,
    [LIST_DOCUMENTS_SET]: (state, action) => ({
        ...state,
        documents: {
            ...state.documents,
            data: action.payload.documents,
            load: LOAD_STATE.SUCCESS,
        },
    }),
    [LIST_TEMPLATES_SET]: (state, action) => ({
        ...state,
        templates: {
            ...state.templates,
            data: action.payload.templates,
            load: LOAD_STATE.SUCCESS,
        },
    }),
    [DELETE_DOCUMENT]: (state, action) => ({
        ...state,
        documents: {
            ...state.documents,
            data: state.documents.data.filter(doc => doc.id !== action.payload.documentId),
        },
    }),
});
